<template>
  <div class="integrated">
    <div class="header">
      <div class="title">安全、稳定软硬一体化产品</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <div class="left">
        <div class="list">
          <div
            class="item"
            v-for="item in leftList"
            :key="item.id"
            :style="
              titleId == item.id
                ? 'background: #f5faff;box-shadow: inset 10px 10px 20px 1px rgba(33, 53, 135, 0.1);'
                : ''
            "
            @mouseenter="clickTitle(item.id)"
          >
            <img :src="item.logo" alt="" />
            <div>{{ item.title }}</div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="item" v-for="item in rightList" :key="item.id">
          <div class="box" v-if="item.id == titleId">
            <div class="top">
              <div class="flex">
                <div class="title">{{ item.title }}</div>
                <router-link :to="item.path">
                  <div class="more">了解更多 ></div>
                </router-link>
              </div>
              <div class="text-list">
                <div
                  class="text-item"
                  v-for="(it, inx) in item.textList"
                  :key="inx"
                >
                  {{ it }}
                </div>
              </div>
            </div>

            <div class="iot" v-if="item.id == 2">
              <img :src="integratedImg" alt="" />
            </div>

            <div class="bottom" v-else>
              <div class="box-list" v-for="i in item.list" :key="i.id">
                <div class="title">{{ i.title }}</div>
                <div class="list">
                  <div class="item-list" v-for="ie in i.list" :key="ie.id">
                    <img :src="ie.logo" alt="" />
                    <div>{{ ie.title }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import integratedLogo1 from "../../../assets/product/integratedLogo1.png";
import integratedLogo2 from "../../../assets/product/integratedLogo2.png";
import integratedLogo3 from "../../../assets/product/integratedLogo3.png";
import integratedLogo4 from "../../../assets/product/integratedLogo4.png";
import integratedLogo5 from "../../../assets/product/integratedLogo5.png";

import integratedList1 from "../../../assets/product/integratedList1.png";
import integratedList2 from "../../../assets/product/integratedList2.png";
import integratedList3 from "../../../assets/product/integratedList3.png";
import integratedList4 from "../../../assets/product/integratedList4.png";
import integratedList5 from "../../../assets/product/integratedList5.png";
import integratedList6 from "../../../assets/product/integratedList6.png";
import integratedList7 from "../../../assets/product/integratedList7.png";
import integratedList8 from "../../../assets/product/integratedList8.png";
import integratedList9 from "../../../assets/product/integratedList9.png";
import integratedList10 from "../../../assets/product/integratedList10.png";
import integratedList11 from "../../../assets/product/integratedList11.png";
import integratedList12 from "../../../assets/product/integratedList12.png";
import integratedList13 from "../../../assets/product/integratedList13.png";
import integratedList14 from "../../../assets/product/integratedList14.png";
import integratedList15 from "../../../assets/product/integratedList15.png";
import integratedList16 from "../../../assets/product/integratedList16.png";
import integratedList17 from "../../../assets/product/integratedList17.png";
import integratedList18 from "../../../assets/product/integratedList18.png";
import integratedList19 from "../../../assets/product/integratedList19.png";
import integratedList20 from "../../../assets/product/integratedList20.png";
import integratedList21 from "../../../assets/product/integratedList21.png";
import integratedList22 from "../../../assets/product/integratedList22.png";
import integratedList23 from "../../../assets/product/integratedList23.png";
import integratedList24 from "../../../assets/product/integratedList24.png";
import integratedList25 from "../../../assets/product/integratedList25.png";
import integratedList26 from "../../../assets/product/integratedList26.png";
import integratedList27 from "../../../assets/product/integratedList27.png";
import integratedList28 from "../../../assets/product/integratedList28.png";
import integratedList29 from "../../../assets/product/integratedList29.png";
import integratedList30 from "../../../assets/product/integratedList30.png";
import integratedList31 from "../../../assets/product/integratedList31.png";
import integratedList32 from "../../../assets/product/integratedList32.png";
import integratedList33 from "../../../assets/product/integratedList33.png";
import integratedList34 from "../../../assets/product/integratedList34.png";
import integratedList35 from "../../../assets/product/integratedList35.png";
import integratedList36 from "../../../assets/product/integratedList36.png";
import integratedList37 from "../../../assets/product/integratedList37.png";
import integratedList38 from "../../../assets/product/integratedList38.png";
import integratedList39 from "../../../assets/product/integratedList39.png";
import integratedList40 from "../../../assets/product/integratedList40.png";
import integratedList41 from "../../../assets/product/integratedList41.png";
import integratedList42 from "../../../assets/product/integratedList42.png";
import integratedList43 from "../../../assets/product/integratedList43.png";

import integratedImg from "../../../assets/product/integratedImg.png";

export default {
  setup() {
    return reactive({
      integratedImg: integratedImg,
      titleId: 1,
      leftList: [
        {
          id: 1,
          title: "数字家园管理系统",
          logo: integratedLogo1,
        },
        {
          id: 2,
          title: "物联网平台",
          logo: integratedLogo2,
        },
        {
          id: 3,
          title: "物业APP、小程序",
          logo: integratedLogo3,
        },
        {
          id: 4,
          title: "业主APP、小程序",
          logo: integratedLogo4,
        },
        {
          id: 5,
          title: "数字家园工单系统",
          logo: integratedLogo5,
        },
      ],
      rightList: [
        {
          id: 1,
          title: "畅月数字家园管理系统",
          path: "/pc/product/adminsystem",
          textList: [
            "收费管理",
            "业主管理",
            "报事报修",
            "财务管理",
            "客户服务",
            "资源管理",
            "OA办公",
          ],
          list: [
            {
              id: 1,
              title: "畅月数组家园解决方案",
              list: [
                {
                  id: 1,
                  title: "管理数字化 服务数字化",
                  logo: integratedList1,
                },
                {
                  id: 2,
                  title: "全面移动化",
                  logo: integratedList2,
                },
                {
                  id: 3,
                  title: "核心能力平台",
                  logo: integratedList3,
                },
                {
                  id: 4,
                  title: "平台数据化",
                  logo: integratedList4,
                },
              ],
            },
            {
              id: 2,
              title: "畅月数字家园管理平台服务",
              list: [
                {
                  id: 1,
                  title: "员工APP",
                  logo: integratedList5,
                },
                {
                  id: 2,
                  title: "业主APP",
                  logo: integratedList6,
                },
                {
                  id: 3,
                  title: "公众号",
                  logo: integratedList7,
                },
                {
                  id: 4,
                  title: "小程序",
                  logo: integratedList8,
                },
              ],
            },
            {
              id: 3,
              title: "畅月数字家园硬件服务",
              list: [
                {
                  id: 1,
                  title: "智能门锁",
                  logo: integratedList9,
                },
                {
                  id: 2,
                  title: "智能停车",
                  logo: integratedList10,
                },
                {
                  id: 3,
                  title: "智能监控",
                  logo: integratedList11,
                },
                {
                  id: 4,
                  title: "楼宇对讲",
                  logo: integratedList12,
                },
              ],
            },
          ],
        },
        {
          id: 2,
          title: "物联网平台",
          path: "/pc/product/things",
          textList: [
            "智能门锁",
            "智能监控",
            "楼宇对讲",
            "智能梯控",
            "智能家居",
            "智能充电",
            "智能停车",
            "智能能耗",
          ],
        },
        {
          id: 3,
          title: "物业APP、小程序",
          path: "/pc/product/property",
          textList: ["移动办公", "协同办公", "物业急速响应", "实时智能分析"],
          list: [
            {
              id: 1,
              title: "物业移动、协同办公",
              list: [
                {
                  id: 1,
                  title: "巡更巡查",
                  logo: integratedList13,
                },
                {
                  id: 2,
                  title: "工单处理",
                  logo: integratedList14,
                },
                {
                  id: 3,
                  title: "离线抄表",
                  logo: integratedList15,
                },
                {
                  id: 4,
                  title: "在线收费",
                  logo: integratedList16,
                },
              ],
            },
            {
              id: 2,
              title: "移动综合管控",
              list: [
                {
                  id: 1,
                  title: "人员考勤管理",
                  logo: integratedList17,
                },
                {
                  id: 2,
                  title: "办公审批管理",
                  logo: integratedList18,
                },
                {
                  id: 3,
                  title: "排班管理",
                  logo: integratedList19,
                },
                {
                  id: 4,
                  title: "数据统计分析",
                  logo: integratedList20,
                },
              ],
            },
            {
              id: 3,
              title: "实时社区监管",
              list: [
                {
                  id: 1,
                  title: "监控中心",
                  logo: integratedList21,
                },
                {
                  id: 2,
                  title: "设备状态监控",
                  logo: integratedList22,
                },
                {
                  id: 3,
                  title: "告警信息监控",
                  logo: integratedList23,
                },
              ],
            },
          ],
        },
        {
          id: 4,
          title: "业主APP、小程序",
          path: "/pc/product/resident",
          textList: [
            "一键开门",
            "在线缴费",
            "通知公告",
            "投诉建议",
          ],
          list: [
            {
              id: 1,
              title: "物业服务",
              list: [
                {
                  id: 1,
                  title: "一件报修",
                  logo: integratedList24,
                },
                {
                  id: 2,
                  title: "在线缴费",
                  logo: integratedList25,
                },
                {
                  id: 3,
                  title: "通知公告",
                  logo: integratedList26,
                },
                {
                  id: 4,
                  title: "投诉建议",
                  logo: integratedList27,
                },
              ],
            },
            {
              id: 2,
              title: "生活服务",
              list: [
                {
                  id: 1,
                  title: "快速领取",
                  logo: integratedList28,
                },
                {
                  id: 2,
                  title: "社区活动",
                  logo: integratedList29,
                },
                {
                  id: 3,
                  title: "预约服务",
                  logo: integratedList30,
                },
              ],
            },
            {
              id: 3,
              title: "智能家居",
              list: [
                {
                  id: 1,
                  title: "智能门禁",
                  logo: integratedList31,
                },
                {
                  id: 2,
                  title: "智能监控",
                  logo: integratedList32,
                },
                {
                  id: 3,
                  title: "智能停车",
                  logo: integratedList33,
                },
                {
                  id: 4,
                  title: "智能充电",
                  logo: integratedList34,
                },
              ],
            },
          ],
        },
        {
          id: 5,
          title: "数字家园工单系统",
          path: "/pc/product/workorder",
          textList: [
            "自助服务",
            "智能派单",
            "仓储联动",
          ],
          list: [
            {
              id: 1,
              title: "多渠道报事报修",
              list: [
                {
                  id: 1,
                  title: "业主线上报修",
                  logo: integratedList35,
                },
                {
                  id: 2,
                  title: "物业内部下单",
                  logo: integratedList36,
                },
                {
                  id: 3,
                  title: "线上客服下单",
                  logo: integratedList37,
                },
              ],
            },
            {
              id: 2,
              title: "全场景覆盖",
              list: [
                {
                  id: 1,
                  title: "公区报修",
                  logo: integratedList38,
                },
                {
                  id: 2,
                  title: "室内有偿维修",
                  logo: integratedList39,
                },
                {
                  id: 3,
                  title: "保洁卫生",
                  logo: integratedList40,
                },
                {
                  id: 4,
                  title: "服务进度",
                  logo: integratedList41,
                },
              ],
            },
            {
              id: 3,
              title: "工单流程闭环",
              list: [
                {
                  id: 1,
                  title: "闭环控制",
                  logo: integratedList42,
                },
                {
                  id: 2,
                  title: "全程进度消息提醒",
                  logo: integratedList43,
                },
              ],
            },
          ],
        },
      ],
    });
  },
  methods: {
    clickTitle(id) {
      this.titleId = id;
    },
  },
};
</script>

<style scoped>
.integrated {
  width: 1180px;
  margin: 80px auto 0;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body {
  display: flex;
  margin-top: 40px;
}
.body .left .list .item {
  width: 280px;
  display: flex;
  align-items: center;
  padding: 24px 20px;
  cursor: pointer;
}
.body .left .list .item img {
  width: 48px;
  margin-right: 20px;
}
.body .left .list .item div {
  font-size: 18px;
}
.body .right {
  width: 900px;
  padding: 30px;
  background: #f5faff;
  box-shadow: inset 10px 10px 20px 1px rgba(33, 53, 135, 0.1);
}
.body .right .item .box .top {
  padding-bottom: 20px;
  border-bottom: 1px solid #dce1e8;
}
.body .right .item .box .top .flex {
  display: flex;
  align-items: center;
}
.body .right .item .box .top .flex .title {
  font-size: 20px;
  margin-right: 20px;
  color: #2a3d50;
}
.body .right .item .box .top .flex .more {
  font-size: 14px;
  color: #248efb;
  cursor: pointer;
}

.body .right .item .box .top .text-list {
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.body .right .item .box .top .text-list .text-item {
  padding: 5px 8px;
  background: #d1d8e1;
  font-size: 14px;
  color: #495a6c;
  margin-right: 20px;
}

.body .right .item .box .bottom .box-list {
  margin-top: 30px;
}
.body .right .item .box .bottom .box-list .title {
  color: #495a6c;
  font-size: 18px;
}
.body .right .item .box .bottom .box-list .list {
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.body .right .item .box .bottom .box-list .list .item-list {
  width: 184px;
  display: flex;
  align-items: center;
  margin-right: 16px;
}
.body .right .item .box .bottom .box-list .list .item-list img {
  width: 24px;
  margin-right: 10px;
}
.body .right .item .box .bottom .box-list .list .item-list div {
  font-size: 14px;
}
.iot {
  text-align: center;
}
.iot img {
  width: 562px;
}
</style>
